import styled from 'styled-components';
import Colors from './colors';

export const CheckoutWrapper = styled.div`
  width: 100%;
  align-self: center;
`;

export const CheckoutBody = styled.div`
  background: #fff;
  border-radius: 10px;
  max-width: 600px;

  @media (min-width: 1200px) {
    min-width: 520px;
  }
`;

export const CreditCardForm = styled.form`
  .powered-by {
    display:flex;
    align-items: center;
    justify-content: space-between;

    .notice {
      display: flex;

      i {
        font-size: 16px;
        padding: 2px 5px 2px 0;
      }
    }

    .logo {
      background-color: #f76b1c;
      overflow: hidden;
      width: 138px;
      margin-right: -8px;
    }
  }
`;

export const PayButton = styled.button`
  width: 100%;
  height: 46px;
  background-color: ${props => props.processing ? '#404040' : Colors.mainOrange};
  font-size: 1.4rem;
  margin-bottom: 15px;
`;
